import React from 'react';
import RoleList from '../components/RoleList';

const RoleListPage: React.FC = () => <RoleList />;

export default RoleListPage;
